module.exports = __webpack_public_path__ + "img/people@8x.1cf19d5e.png";